import React, { useState, useRef, useEffect, useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AudioRecorder = ({
    audioURL,
    setAudioURL,
    setAudioBlob,
    sendingParticipationState,
    setMessageErreur,
    changerEtapeCollecteParticipationVocale,
    maxRecordingTime,
    onStartRecording,
    onRestartRecording,
}) => {
    const [recording, setRecording] = useState(null);
    // const [continueEnabled, setContinueEnabled] = useState(false);

    const recorderRef = useRef();

    const handleRecord = async () => {
        setMessageErreur('');
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        recorderRef.current = new MediaRecorder(stream);

        const chunks = [];
        recorderRef.current.addEventListener('dataavailable', (event) => {


            if (event.data) {

                chunks.push(event.data);
                var audioBlob = new Blob(chunks);
                if (chunks[0].type && audioBlob.type === '') {

                    audioBlob = new Blob(chunks, { type: chunks[0].type });
                } else if (audioBlob.type === '') {

                    audioBlob = new Blob(chunks, { type: 'audio/wav' });
                }
                const url = URL.createObjectURL(audioBlob);
                setAudioURL(url);
                setAudioBlob(audioBlob);

            }

        });

        recorderRef.current.addEventListener('stop', () => {
            var audioBlob = new Blob(chunks);
            if (chunks[0].type && audioBlob.type === '') {
                audioBlob = new Blob(chunks, { type: chunks[0].type });
            } else if (audioBlob.type === '') {
                audioBlob = new Blob(chunks, { type: 'audio/wav' });
            }
            const url = URL.createObjectURL(audioBlob);
            setAudioURL(url);
            setAudioBlob(audioBlob);

            setRecording(false);


        });

        onStartRecording('start');
        recorderRef.current.start();
        setRecording(recorderRef.current);
    }

    useEffect(() => {
        if (!audioURL) {

        }

    }, [audioURL])

    const handleStop = useCallback(async () => {
        // setContinueEnabled(true);
        await recorderRef.current.stop();
    }, [recorderRef]);

    const handleRemove = () => {
        onRestartRecording();
        setAudioURL('');
        // setContinueEnabled(false);

    };

    // Stop l'enregistrement à la fin du temps autorisé si il y en a un.
    useEffect(() => {
        if (maxRecordingTime) {
            let timer;
            if (recording) {
                timer = setTimeout(() => {
                    handleStop();
                }, maxRecordingTime * 1000);
            }
            return () => clearTimeout(timer);
        }
    }, [recording, maxRecordingTime, handleStop]);

    useEffect(() => {
        if (!window.MediaRecorder) {
            window.MediaRecorder = require('audio-recorder-polyfill');
        }
    }, []);

    return (
        <>
            {audioURL ? (
                <>
                    <Row className="text-center">
                        <Col>
                            <audio src={audioURL} controls />
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>

                            <Button onClick={handleRemove} className="btn-refaire-enregistrement-vocale">Recommencer l'enregistrement</Button>
                            {maxRecordingTime => 0 &&
                                <>
                                    <p>Limite: {maxRecordingTime * 1000}seconds</p>
                                </>
                            }



                            {sendingParticipationState === 'sending' &&
                                <p>Envoi en cours ...</p>
                            }
                        </Col>
                    </Row>
                    <Row className="custom-commandes">
                        <Col>
                            <Button onClick={changerEtapeCollecteParticipationVocale} >Continuer</Button>
                        </Col>
                    </Row>
                </>
            ) : (
                <>
                    {recording ? (
                        <>
                            <Row className="text-center">
                                <Col><Button onClick={handleStop} className="btn-stop-enregistrement-vocale">&nbsp;</Button></Col>
                            </Row>

                            <Row className="text-center btn-enregistrements temps-maximum">
                                <Col>
                                    {maxRecordingTime && (
                                        <p>Temps maximum autorisé {maxRecordingTime}s</p>
                                    )}
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>
                            <Row className="text-center btn-enregistrements">
                                <Col>
                                    <Button onClick={handleRecord} className="btn-enregistrement-vocale">&nbsp;</Button>
                                </Col>
                            </Row>

                            <Row className="text-center btn-enregistrements temps-maximum">
                                <Col>

                                    {maxRecordingTime && (
                                        <p className='text-size-12'>Temps maximum autorisé {maxRecordingTime}s</p>
                                    )}
                                </Col>
                            </Row>
                        </>
                    )}
                </>
            )}

        </>
    );
}

export default React.memo(AudioRecorder);